export const PLAN_ECOMMERCE_PLUS = 'ECOMMERCEPLUS';
export const PLAN_FREE = 'FREE';
export const SUBSCRIPTION_STATUS_ACTIVE = 'ACTIVE';
